import bodybuilder from 'bodybuilder'
import Moment from 'moment'
import * as Redux from 'redux'
import * as DateSelector from '../../../components/date-selector'
import * as Elasticsearch from '../../../elasticsearch'
import * as Request from '../../../request'
import * as Constants from './constants'
import * as Types from './types'

export const todayUpdateSelectedDate = (date: Types.SelectedDate) =>
  ({type: Constants.UPDATE_SELECTED_DATE, date})

export type FetchNewsbriefsActionCreator =
  (community: DateSelector.CommunityIdentifier, date: Types.SelectedDate) => Request.RequestAction

export const fetchIssues: FetchNewsbriefsActionCreator =
  (community: DateSelector.CommunityIdentifier, date: Types.SelectedDate) =>
  Request.requestActionCreator(Constants.FETCH_TODAY_ISSUES)
  ({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/${community}/date/${date ? date : Moment().format('YYYY-MM-DD')}`,
  })

export type FetchSubjectLinesActionCreator =
  (community: DateSelector.CommunityIdentifier, issues: Types.Issue[]) => Request.RequestAction

export const fetchSubjectLines: FetchSubjectLinesActionCreator =
  (community: DateSelector.CommunityIdentifier, issues: Types.Issue[]) =>
  Request.requestActionCreator(Constants.FETCH_TODAY_SUBJECT_LINES)
  ({
    method: 'GET',
    url: `${Constants.SERVER_SUBJECT_LINE_RESOURCE}/${community}?issues=${issues.map((i: Types.Issue) => i.id)}`,
  })

export type FetchActionsActionCreator =
  (community: DateSelector.CommunityIdentifier, issues: Types.Issue[]) => Request.RequestAction

export const fetchActions: FetchActionsActionCreator =
  (community: DateSelector.CommunityIdentifier, issues: Types.Issue[]) =>
  Elasticsearch.createEsSearch(Constants.FETCH_TODAY_ACTIONS)(
    community,
    Elasticsearch.Indexes.TopClicks.EmailActions,
    bodybuilder().size(20)
    .sort('created', 'desc')
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
      community)
    .filter(
      'term',
      Elasticsearch.DocumentFieldNames.IncludeInReports,
      true)
    .filter(
      'terms',
      Elasticsearch.DocumentFieldNames.IssueId,
      issues.map((i: Types.Issue) => i.id))
    .aggregation(
      'terms',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.EventName),
      Elasticsearch.DocumentFieldNames.EventName,
      (uniques: any) => uniques.aggregation(
        'cardinality',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.CommunityPersonGuid),
        Elasticsearch.AggFieldNames.UniqueCount))
    .aggregation(
      'date_histogram',
      Elasticsearch.DocumentFieldNames.EventTimestamp,
      { interval: 'hour' },
      Constants.HOURLY_COUNT,
      (hours: any) => hours.aggregation(
        'terms',
        Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.EventName),
        Elasticsearch.DocumentFieldNames.EventName,
        (uniques: any) => uniques.aggregation(
          'cardinality',
          Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.CommunityPersonGuid),
          Elasticsearch.AggFieldNames.UniqueCount)))
    .build(),
  )

export interface SelectDateAction extends Redux.Action {date: Types.SelectedDate}
export type SelectDateActionCreator = (date: Types.SelectedDate) => SelectDateAction
export const updateSelectedDate = (date: Types.SelectedDate) =>
  ({type: Constants.SELECT_TODAY_DATE, date})



// WEBPACK FOOTER //
// ./src/pages/reports/today/actions.ts